import styles from './FormFooter.module.scss';

import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export function FormFooter(props: Props) {
  return <div className={styles['form-footer']}>{props.children}</div>;
}
